<template>
  <div>
    <!-- Sched Training Modal-->
    <div
      class="modal fade"
      id="completeTraining"
      tabindex="-1"
      role="dialog"
      aria-labelledby="completeTrainingModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="completeTrainingModalLabel"
            >
              Modal title
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- add crew modal  -->
          <div class="modal-body">
            <!-- trainingCourseName -->
            <div class="row" />

            <!-- status -->
            <div class="row" />

            <!-- days -->
            <div class="row" />

            <!-- description -->
            <div class="row" />


            <!-- time from -->
            <div />


            <!-- time to -->
            <div />

            <!-- dateFrom -->
            <div class="row" />

            <!-- dateTo -->
            <div class="row" />

            <!-- trainingProvider -->
            <div class="row" />

            <!-- trainingProviderCode -->
            <div class="row" />


            <!-- trainingProviderNumber -->
            <div class="row" />

            <!-- trainingProviderPerson -->
            <div class="row" />

            <!-- venue -->
            <div class="row" />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {
        props: ['id'],
        name: "ViewCompleteTrainings",
        methods: {
            ...mapActions(['viewCrewCompletedTraining']),
        },

        computed: {
            ...mapGetters(['crewCompleteTraining']),
        }
    }
</script>

<style scoped>

</style>